import { Badge } from "../../components/ui";
import { APPROVAL_STATUS } from "../../masters";
import type { ApprovalStatus } from "../../lib/types";

export function StatusBadge({ status }: { status: ApprovalStatus }) {
  const meta = APPROVAL_STATUS[status] ?? { label: status, tone: "gray" as const };
  return <Badge tone={meta.tone}>{meta.label}</Badge>;
}
